import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';
import { CreateRole, MultiRoleCreate, Role, RoleListResponse, RoleQueryParams, UpdateRole } from '@frontend/role/types';

export class RoleClient extends APIClient {
    public static readonly endpoint = '/authorization-api/v1';

    public static async fetchRoles(queryParams?: ApiQueryParams<RoleQueryParams>): Promise<RoleListResponse> {
        return await this.apiPaginated<RoleListResponse, DefaultQueryParams>(`${this.endpoint}/roles`, queryParams);
    }

    public static async deleteRoles(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/roles-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async fetchEntityRoles(
        accountId: string,
        entityType: EntityType,
        entityId: string,
        queryParams?: ApiQueryParams<RoleQueryParams>
    ): Promise<RoleListResponse> {
        return await this.apiPaginated<RoleListResponse, DefaultQueryParams>(
            `${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}/roles`,
            queryParams
        );
    }

    public static async postRole(accountId: string, entityType: EntityType, entityId: string, role: CreateRole | MultiRoleCreate): Promise<Role> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}/roles`, role);
        return await this.handleResponse<Role>(response);
    }

    public static async fetchRole(accountId: string, entityType: EntityType, entityId: string, roleId: string): Promise<Role> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}/roles/${roleId}`);
        return await this.handleResponse<Role>(response);
    }

    public static async patchRole(accountId: string, entityType: EntityType, entityId: string, roleId: string, role: UpdateRole): Promise<Role> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}/roles/${roleId}`, role);
        return await this.handleResponse<Role>(response);
    }

    public static async deleteRole(accountId: string, entityType: EntityType, entityId: string, roleId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/${entityType}s/${entityId}/roles/${roleId}`);
        return await this.handleVoidResponse(response);
    }
}
